import axios from 'axios';

const initialState = {
  taskCategories: [],
  isError: false,
  errorMsg: '',
  isSuccess: false,
  isLoading: false,
};

export default {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    setTaskCategories(state, payload) {
      state.taskCategories = payload;
    },
    setError(state, err) {
      state.isError = true;
      state.errorMsg = err;
    },
    setIsLoading(state, bool) {
      state.isLoading = bool;
    },
    setSuccess(state, bool) {
      state.isLoading = false;
      state.isError = false;
      state.errorMsg = '';
      state.isSuccess = bool;
    },
    clearMessages(state) {
      state.isLoading = false;
      state.isError = false;
      state.errorMsg = '';
      state.isSuccess = false;
    },
  },

  actions: {
    async fetchTaskCategories({ commit }) {
      try {
        commit('setIsLoading', true);
        const res = await axios.get(`${process.env.VUE_APP_ACCOUNTS_API}/users/task-categories?$limit=0&$sort[numRanking]=1`);
        commit('setTaskCategories', res.data.data);
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
    async saveTaskCategory({ commit }, payload) {
      try {
        commit('setIsLoading', true);
        delete payload.id;
        payload.rank = parseInt(payload.rank, 10);
        await axios.post(`${process.env.VUE_APP_ACCOUNTS_API}/users/task-categories`, payload);
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
    async updateTaskCategory({ commit }, payload) {
      try {
        commit('setIsLoading', true);
        payload.rank = parseInt(payload.rank, 10);
        await axios.patch(`${process.env.VUE_APP_ACCOUNTS_API}/users/task-categories/${payload.id}`, payload);
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
    async updateRanks({ commit }, payload) {
      try {
        commit('setIsLoading', true);
        await axios.put(
          `${process.env.VUE_APP_ACCOUNTS_API}/users/task-categories/ranks`,
          payload,
        );
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
    async deleteTaskCategory({ commit }, id) {
      try {
        commit('setIsLoading', true);
        await axios.delete(
          `${process.env.VUE_APP_ACCOUNTS_API}/users/task-categories/${id}`,
        );
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
  },
};
